<template>
    <svg
        width="10"
        height="16"
        viewBox="0 0 10 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9 15L2 7.55046L9 1"
            stroke="currentColor"
            stroke-width="2"
        />
    </svg>
</template>

<script setup lang="ts"></script>
